import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux"; // Assuming you're using Redux
import Constant from "../../../Constant/Constant";
import useSessionData from "../../../hooks/useSessionData";

const LogoLink = React.memo(({ isToggle }) => {
  const sessionList = useSelector((state) => state.sessionData.sessionScope);
  const [logo, setLogo] = useState("/../assets/image/logo_vasyerp_nav.png");

  // const { sessionList } = useSessionData();

  useEffect(() => {
    const { companyId, jioType } = sessionList;
    if (companyId === 461) {
      setLogo("/image/461.jpg");
    } else {
      switch (jioType) {
        case Constant.JIO_TYPE_JPM:
        case Constant.JIO_TYPE_FJSK:
          setLogo("/../restaurant-pos/images/vasy-jpm-logo-light.png");
          break;
        case Constant.JIO_TYPE_AJIO:
          setLogo("/../assets/image/vasy_ajio_logo_white.png");
          break;
        case Constant.JIO_TYPE_AJIO_WHOLESALER:
        case Constant.JIO_TYPE_AJIO_DISTRIBUTOR:
          setLogo("/../assets/image/vasy_ajiowholesaler_logo_white.png");
          break;
        default:
          setLogo("/../assets/image/logo_vasyerp_nav.png");
      }
    }
  }, [sessionList.companyId, sessionList.jioType]);

  return !isToggle ? (
    <div className="m-stack__item m-stack__item--middle" id="m-logo_div_header">
      <a href="/" className="m-brand__logo-wrapper">
        <img
          alt="Logo"
          src={logo}
          style={{
            width: "155px",
            height: sessionList.companyId === 461 ? "50px" : "auto",
          }}
        />
      </a>
    </div>
  ) : null;
});

export default LogoLink;
